import { Button, Box, Typography } from '@mui/material';
import { Icon24UtilityFilters } from '@care/react-icons';
import { Dispatch, SetStateAction } from 'react';
import { trackAmplitudeEvent, AmplitudeEvent } from '@/lib/analyticsHelper';

interface FiltersCTAProps {
  setOpenFiltersPopover?: Dispatch<SetStateAction<boolean>>;
  setOpenFiltersModal?: Dispatch<SetStateAction<boolean>>;
  setPopoverAnchorEl?: Dispatch<SetStateAction<(EventTarget & Element) | null>>;
}

const FiltersCTA = ({
  setOpenFiltersPopover,
  setOpenFiltersModal,
  setPopoverAnchorEl,
}: FiltersCTAProps) => {
  const handleFiltersCTAClick = (event: React.MouseEvent) => {
    if (setOpenFiltersModal) {
      setOpenFiltersModal(true);
    }
    if (setOpenFiltersPopover) {
      setOpenFiltersPopover(true);
    }
    if (setPopoverAnchorEl) {
      setPopoverAnchorEl(event.currentTarget);
    }

    trackAmplitudeEvent(AmplitudeEvent.seoFeatureInteracted, {
      feature_name: 'Filters Viewed',
    });
  };

  return (
    <Box mb={{ md: 6 }}>
      <Button variant="outlined" size="small" color="secondary" onClick={handleFiltersCTAClick}>
        <Box display="flex" justifyContent="center" alignItems="center">
          <Box pr={1} pt={1}>
            <Icon24UtilityFilters />
          </Box>
          <Typography component="span" variant="body1">
            Filter
          </Typography>
        </Box>
      </Button>
    </Box>
  );
};

export { FiltersCTA };
